import React from 'react';
import clsx from 'clsx';
import Dialog from '@components/atoms/dialog/dialog';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import Button from '@components/atoms/button/button';
import styles from './banner-box-modal.module.scss';

type BannerBoxModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const BannerBoxModal = ({ isOpen, onClose }: BannerBoxModalProps) => {
  const { t } = useTranslation('price-drop');

  return (
    <Dialog
      key="buyerFeesModale"
      isOpen={isOpen}
      closeDialog={onClose}
      hasCloseIcon
      styles={{
        content: {
          maxWidth: '660px',
          width: '100%',
        },
      }}
    >
      {(modalDialogTitleId) => (
        <div className={styles.modalBody}>
          <section className={styles.intro}>
            <h1
              className={clsx('vc-heading-A24', styles.intro__title)}
              id={modalDialogTitleId}
            >
              {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.CHANCE_TITLE')}
            </h1>
            <p className={styles.intro__description}>
              {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.CHANCE_DESCRIPTION')}
            </p>
          </section>
          <section className={styles.recoInfo}>
            <h1 className={clsx('vc-heading-A24', styles.recoInfo__title)}>
              {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_TITLE')}
            </h1>
            <ul>
              <li className={styles.recoInfo__row}>
                <Icon
                  name="my-sizes-default"
                  className={styles.recoInfo__row__icon}
                  ariaHidden
                />
                <div>
                  <h2 className={styles.recoInfo__row__title}>
                    {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_SIMILAR_SOLD_TITLE')}
                  </h2>
                  <p className={styles.recoInfo__row__description}>
                    {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_SIMILAR_SOLD_DESC')}
                  </p>
                </div>
              </li>
              <li className={styles.recoInfo__row}>
                <Icon
                  name="trend-default"
                  className={styles.recoInfo__row__icon}
                  ariaHidden
                />
                <div>
                  <h2 className={styles.recoInfo__row__title}>
                    {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_MARKET_TITLE')}
                  </h2>
                  <p className={styles.recoInfo__row__description}>
                    {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_MARKET_DESC')}
                  </p>
                </div>
              </li>
              <li className={styles.recoInfo__row}>
                <Icon
                  name="refund-default"
                  className={styles.recoInfo__row__icon}
                  ariaHidden
                />
                <div>
                  <h2 className={styles.recoInfo__row__title}>
                    {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_PRICE_TITLE')}
                  </h2>
                  <p className={styles.recoInfo__row__description}>
                    {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.FACTORS_PRICE_DESC')}
                  </p>
                </div>
              </li>
            </ul>
          </section>

          <Button
            type="button"
            size="large"
            data-cy="price-zone-modal-close"
            onClick={onClose}
            variant={'primary'}
            className={styles.modalBody__gotit}
          >
            {t('PRICE_DROP.PRICE_ZONE.CONVERSION.MODAL.GOT_IT')}
          </Button>
        </div>
      )}
    </Dialog>
  );
};
